import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { useAppleOAuthSignIn } from './useAppleOAuthSignIn';
import { useAppleLoginNonce } from './useAppleLoginNonce';
import { useLoadAppleAuth } from './useLoadAppleAuth';
import { OAuthButton } from '../oauth/OAuthButton';
import { useSelector } from 'react-redux';
import { getIsAppleLoading } from '../store/app/selectors';
import { useLoadAppleScript } from './useLoadAppleScript';
export const AppleButton = () => {
  const [shouldSignInWithApple, setShouldSignInWithApple] = useState(false);
  const {
    appleNonce
  } = useAppleLoginNonce();
  const isAuthLoading = useSelector(getIsAppleLoading);
  const {
    isAppleScriptLoading
  } = useLoadAppleScript();
  useLoadAppleAuth(appleNonce);
  useAppleOAuthSignIn({
    shouldSignInWithApple,
    setShouldSignInWithApple
  });

  const handleOnClick = () => {
    setShouldSignInWithApple(true);
  };

  return /*#__PURE__*/_jsx(OAuthButton, {
    isLoading: isAuthLoading || isAppleScriptLoading,
    oauth: OAuthProviders.Apple,
    onClick: handleOnClick
  });
};